import { VisaLandingPageController } from "./landing-page.controller";
import { Bindings } from "booking_app/types";

export class VisaLandingPage {
  bindings: any = {
    data: Bindings.ONE_WAY,
  };

  controller: any = VisaLandingPageController;
  template: string = `
    <div class="landing-screen-container">

      <div class="search-form-container">
        <hotels-search-form></hotels-search-form>
      </div>

      <div class="content-container" ng-style="$ctrl.$rootScope.landingPage.backgroundImgStyle()">
        <div class="cc-info">
          <div class="covid19">
            <span class="covid19-message">
              {{ 'txt.covid19.message' | translate }}
              <a href= "/company/visa-covid-19">
              {{ 'txt.covid19.find_more' | translate }}
              </a>
            </span>
          </div>
          <div class="cc-info-title">
            {{ 'wl.visa.cc_info_title' | translate }}
          </div>

          <div class="cc-info-description">
            <img class="cc-info-image" cdn-path="/visa/prod/cc_face.png">
            <div>
              <ul>
                <li>{{ 'wl.cc_info_description_1' | translate }}</li>
                <li>{{ 'wl.cc_info_description_2' | translate }}</li>
                <li>{{ 'wl.cc_info_description_3' | translate }}</li>
              </ul>
            </div>
          </div>

        </div>
      </div>

    </div>
  `;
}

angular.module("BookingApp").component("visaLandingPage", new VisaLandingPage());
